'use strict';

import { UserIdentity } from '../../util';

function getPath( url ) {
  if ( url.indexOf( '#' ) ) {
    url = url.split( '#' )[0];
  }
  if ( url.endsWith( '/' ) ) {
    return url;
  }
  let parts = url.split( '/' );
  return parts.slice( 0, parts.length - 1 ).join( '/' );
}

function getSiteRootPath( noOverride ) {
  if ( !noOverride && global && global.overrides && global.overrides.site ) {
    return global.overrides.site.url;
  }
  if ( !getSiteRootPath.url ) {
    let location = global && global.document ? global.document.location : {
      protocol: 'http:',
      hostname: 'localhost',
      pathname: '/Configit.Portal.Web/'
    };
    // "api" location is determined by site_location defined in index.html.
    // if site_location = root, meaning index.html is directly at site root, then 'api' is in same level as index.html
    // else 'api' path is one level above, so need to go one level up
    // all sites will be using common scripts / css 
    let fullPath = location.protocol + '//' + getPath(
      combine( !location.port ? location.hostname : location.hostname + ':' + location.port, location.pathname, (typeof site_location !== 'undefined' && site_location === 'root' ? '' : '../') )
    );
    getSiteRootPath.url = fullPath;
  }
  return getSiteRootPath.url;
}

function ensureTrailing( value, character ) {
  return value.endsWith( character ) ? value : value + character;
}

function ensureNonLeading( value, character ) {
  return value.startsWith( character ) ? value.substr( 1 ) : value;
}

function removeEmptyArguments() {
  let result = [];
  for ( let i = 0; i < arguments.length; i++ ) {
    if ( !arguments[i] ) {
      continue;
    }
    result.push( arguments[i] );
  }
  return result;
}

function combine() {
  let args = removeEmptyArguments.apply( this, arguments );
  return args.length === 1 ? args[0] :
    Array.prototype.reduce.apply( args, [( currentValue, item ) =>
      currentValue ? ensureTrailing( currentValue, '/' ) + ensureNonLeading( item, '/' ) : ensureTrailing( item, '/' ), ''] );
}

function getConfig( ...customConfigs ) {
  const defaultConfig = { 
    withCredentials: true,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json',
      'Accept-Encoding': 'gzip, deflate, br',
      'Content-Type': 'application/json;charset=utf-8'
    }
  };

  const defaultFormConfig = { 
    withCredentials: true,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json, text/plain, */*',
      'Accept-Encoding': 'gzip, deflate, br',
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  };

  // when there is a valid jwt, include this one
  if ( UserIdentity.jwt ) {
    defaultConfig.headers['Authorization'] = 'Bearer ' + UserIdentity.jwt;
  }

  if ( !customConfigs || !customConfigs.length ) {
    return defaultConfig;
  }

  let config = defaultConfig;
  for ( let customConfig of customConfigs ) {
    if ( customConfig ) {
      let header = { ...config.headers };
      config = { ...config, ...customConfig };
      if(config.xmlContent){
        config = defaultFormConfig;
        header = { ...config.headers };
        config = { ...config, ...customConfig };
      }
      if ( customConfig.headers ) {
        config.headers = { ...header, ...customConfig.headers };
      }
      
      if ( customConfig.body ) {
        if ( config.headers['Content-Type'] === 'multipart/form-data' ) {
          config.body = customConfig.body;
          delete config.headers['Content-Type'];
        }else if ( config.headers['Content-Type'] === 'application/x-www-form-urlencoded;charset=UTF-8' ) {
          config.body = customConfig.body;
        }else {
          config.body = JSON.stringify( customConfig.body );
        }
      }
    }
  }
  return config;
}
//   for ( let customConfig of customConfigs ) {
//     if( customConfig ) {
//       const header = { ...config.headers };
//       config = { ...config, ...customConfig };

//       if( customConfig.headers ) {
//         config.headers = { ...header, ...customConfig.headers };
//       }
//     }
//   }
//   return config;
// }

export const settings = {
  getSiteRootPath,
  combineUrlParts: combine,
  /*
   * @method transform
   * @param {string} url Will return the absolute path to the url based on the current site
   */
  transformApiRoute: url => combine( getSiteRootPath(), 'api', url ),
  transformRoute: url => combine( getSiteRootPath(), url ),
  getConfig: ( ...customConfig ) => getConfig( ...customConfig )
};